module.exports = "\n  <div :class=\"[imageClass, imageState]\" :style=\"computedImage\" :data-width=\"imageWidth\" :data-height=\"imageHeight\" :data-state=\"imageState\">\n    <div :class=\"[previewClass, imageState]\" :style=\"computedPreview\"></div>\n  </div>\n";


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-html-loader!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./source/scripts/components/image-loader-bg.vue
// module id = 113
// module chunks = 2 4 5 7 11